import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Marketplace from "@/pages/Marketplace";
import Categories from "@/pages/Categories";
import ProductDetail from "@/pages/ProductDetail";
import SellerProfile from "@/pages/SellerProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Welcome from "@/pages/Welcome";
import Profile from "@/pages/Profile";
import SellerDashboard from "@/pages/SellerDashboard";
import ListingForm from "@/pages/ListingForm";
import AdminDashboard from "@/pages/AdminDashboard";
import SellerHome from "@/pages/SellerHome";
import { About, Faq, Privacy, Terms, Contact } from "@/pages/Info";

const RequireRole = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#6B7280]">
        ...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const HomeRouter = () => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-[#6B7280]">
        ...
      </div>
    );
  if (user?.role === "seller") return <SellerHome />;
  return <Home />;
};
function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomeRouter />} />
              <Route path="/market" element={<Marketplace />} />
              <Route
                path="/marketplace"
                element={<Navigate to="/market" replace />}
              />
              <Route path="/categories" element={<Categories />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/seller/:id" element={<SellerProfile />} />
              <Route path="/user/:id" element={<SellerProfile />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route
                path="/dashboard"
                element={
                  <RequireRole roles={["seller", "admin"]}>
                    <SellerDashboard />
                  </RequireRole>
                }
              />
              <Route
                path="/dashboard/add"
                element={
                  <RequireRole roles={["seller", "admin"]}>
                    <ListingForm />
                  </RequireRole>
                }
              />
              <Route
                path="/dashboard/edit/:id"
                element={
                  <RequireRole roles={["seller", "admin"]}>
                    <ListingForm />
                  </RequireRole>
                }
              />
              <Route
                path="/admin"
                element={
                  <RequireRole roles={["admin"]}>
                    <AdminDashboard />
                  </RequireRole>
                }
              />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
